"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildSanitizer = void 0;

var _Sanitize = _interopRequireDefault(require("Sanitize"));

var buildSanitizer = function buildSanitizer(config) {
  return new _Sanitize.default(config);
};

exports.buildSanitizer = buildSanitizer;